import React from 'react'
import ImageField from 'components/ImageField/index';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import DatePicker from 'react-datepicker';
import ReactSelect from 'react-select';
import {
  Button,
  Card, CardBody, CardHeader,
  Col,
  Form, FormGroup,
  Input, Label,
  ModalFooter,
  Row
} from 'reactstrap';
import { LangOptions, DefaultFormValue } from './assets';
import MultilingualInput from 'components/MultiLangInput/v2'
import MultilingualRTE from 'components/MultiLangRTE'

import Lang from 'Lang/General';

function IndustryForm({
  data,
  mode,
  stages,
  fairs,
  onSubmit,
  selectedProgramme,
  selectedPortalUsers
}) {
  const [formData, setFormData] = useState({
    ...DefaultFormValue
  })

  useEffect(() => {
    if (mode === 'edit' && selectedProgramme) {
      setFormData({
        ...selectedProgramme,
        start_date_time: selectedProgramme.start_date_time === '0001-01-01T00:00:00Z' ? null : selectedProgramme.start_date_time,
        end_date_time: selectedProgramme.end_date_time === '0001-01-01T00:00:00Z' ? null : selectedProgramme.start_date_time,
        languages: _.map(selectedProgramme.languages, langChild => ({
          value: langChild,
          label: langChild
        }))
      })
    } else {
      setFormData({
        ...DefaultFormValue
      })
    }
  }, [selectedProgramme])

  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  const tempFair = useMemo(() => {
    let temp = _.find(fairs, child => {
      return +formData.fair_id === child.id
    })

    return temp
  }, [fairs, formData.fair_id])

  return (
    <>
      {/* <Form>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <Label>
                {Lang['FAIRS'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <Input
                type={"select"}
                value={formData.fair_id}
                disabled={formData.user_id === null}
                onChange={e => setFormData({
                  ...formData,
                  fair_id: e.target.value,
                  stage_id: null,
                  start_date_time: null,
                  end_date_time: null,
                })}
              >
                <option value={''}></option>
                {
                  _.filter(fairs, fairChild => {
                    if (formData.user_id !== null) {
                      return _.findIndex(selectedPortalUsers.fairs, userFairChild => userFairChild.id === fairChild.id) > -1
                    } else {
                      return false
                    }
                  }).map((data) => (
                    <option key={data.id} value={data.id}>
                      {data.name}
                    </option>
                  ))
                }
              </Input>
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>
                {Lang['STAGES'][data.languageReducer.userSettings.admin_panel_language]}
              </Label>
              <Input
                type={"select"}
                value={formData.stage_id}
                onChange={e => onChangeField('stage_id', e.target.value)}
              >
                <option></option>
                {_.filter(stages, stageChild => stageChild.fair_id === +formData.fair_id).map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col lg={6}>
            <Label>
              {Lang['START_DATETIME'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <DatePicker
              locale={data.languageReducer.userSettings.admin_panel_language}
              className="form-control"
              minDate={tempFair ? new Date(tempFair.start_date) : null}
              maxDate={tempFair ? new Date(tempFair.end_date) : null}
              popperPlacement='bottom-start'
              popperModifiers={{
                flip: { behavior: ['bottom'] },
                preventOverflow: { enabled: false },
                hide: { enabled: false }
              }}
              showTimeSelect={true}
              timeFormat={'HH:mm'}
              dateFormat={`dd/MM/yyyy HH:mm`}
              selected={formData.start_date_time ? new Date(formData.start_date_time) : null}
              onChange={date => setFormData({
                ...formData,
                start_date_time: date,
                end_date_time: null
              })}
            />
          </Col>
          <Col lg={6}>
            <Label>
              {Lang['END_DATETIME'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <DatePicker
              locale={data.languageReducer.userSettings.admin_panel_language}
              className="form-control"
              popperPlacement='bottom-start'
              disabled={!formData.fair_id || !formData.start_date_time}
              minDate={tempFair ? new Date(formData.start_date_time) : null}
              maxDate={tempFair ? new Date(formData.start_date_time) : null}
              popperModifiers={{
                flip: { behavior: ['bottom'] },
                preventOverflow: { enabled: false },
                hide: { enabled: false }
              }}
              showTimeSelect={true}
              timeFormat={'HH:mm'}
              dateFormat={`dd/MM/yyyy HH:mm`}
              selected={formData.end_date_time ? new Date(formData.end_date_time) : null}
              onChange={date => onChangeField('end_date_time', date)}
            />
          </Col>
          <Col lg={12}>
            <Label>
              {Lang['LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <ReactSelect
              isMulti
              options={_.map(LangOptions, lang => ({
                label: Lang[lang][data.languageReducer.userSettings.admin_panel_language],
                value: lang
              }))}
              onChange={val => {
                onChangeField('languages', val)
              }}
              value={formData.languages}
              placeholder={Lang['SELECT_LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]} />
          </Col>
        </Row>
      </Form> */}
      {/* <Card className={'mt-4'}> */}
      {/* <CardHeader>
          {Lang['SPEAKER'][data.languageReducer.userSettings.admin_panel_language]}
        </CardHeader> */}
      {/* <CardBody> */}
      <FormGroup>
        <Label>
          {Lang['LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]}
        </Label>
        <ReactSelect
          isMulti
          options={_.map(LangOptions, lang => ({
            label: Lang[lang][data.languageReducer.userSettings.admin_panel_language],
            value: lang
          }))}
          onChange={val => {
            onChangeField('languages', val)
          }}
          value={formData.languages}
          placeholder={Lang['SELECT_LANGUAGES'][data.languageReducer.userSettings.admin_panel_language]} />
      </FormGroup>
      <FormGroup>
        <Label>{Lang['PORTRAIT'][data.languageReducer.userSettings.admin_panel_language]}</Label>
        <ImageField
          onChange={val => setFormData({
            ...formData,
            portrait: val
          })}
          fileValue={formData?.portrait?.url}
        />
      </FormGroup>
      <FormGroup>
        <Label>
          {Lang['FIRST_NAME'][data.languageReducer.userSettings.admin_panel_language]}
        </Label>
        <Input
          value={formData.first_name}
          onChange={e => setFormData({
            ...formData,
            first_name: e.target.value
          })}
        />
      </FormGroup>
      <FormGroup>
        <Label>
          {Lang['LAST_NAME'][data.languageReducer.userSettings.admin_panel_language]}
        </Label>
        <Input
          value={formData.last_name}
          onChange={e => setFormData({
            ...formData,
            last_name: e.target.value
          })}
        />
      </FormGroup>
      <Row>
        <Col lg={12}>
          <FormGroup>
            <MultilingualInput
              label={Lang['TITLE_OF_LECTURE'][data.languageReducer.userSettings.admin_panel_language]}
              selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
              value={formData.short_description}
              valueName='short_description'
              parent={formData}
              onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
            />
          </FormGroup>
        </Col>
        <Col lg={12}>
          <MultilingualRTE
            height={'200px'}
            label={Lang['DESC_OF_LECTURE'][data.languageReducer.userSettings.admin_panel_language]}
            value={formData.description}
            onChange={val => setFormData({
              ...formData,
              description: val
            })}
            selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
          />
        </Col>
      </Row>
      {/* </CardBody> */}
      {/* </Card> */}
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            let temp = _.cloneDeep(formData)
            if (formData.portrait) {
              temp.portrait = selectedProgramme && formData.portrait.url === selectedProgramme?.portrait.url ? null : {
                raw: formData.portrait.raw,
                filename: formData.portrait.filename
              }
            }
            onSubmit({
              ...temp,
              user_id: selectedPortalUsers.id,
              fair_id: formData.fair_id !== null ? +formData.fair_id : null,
              stage_id: formData.stage_id !== null ? +formData.stage_id : null,
              languages: _.map(formData.languages, langChild => langChild.value)
            })
          }}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default IndustryForm